import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'dcsg-mat-spinner-button',
  templateUrl: './dcsg-mat-spinner-button.component.html',
  styleUrls: ['./dcsg-mat-spinner-button.component.scss']
})
export class DcsgMatSpinnerButtonComponent implements OnInit {

  @Input()
  testId: string;

  @Input()
  btnId: string;

  @Input()
  disabled: boolean;

  @Input()
  btnClass: string;

  @Input()
  btnForm: string;

  @Input()
  btnType: string;

  @Input()
  showSpinner: boolean;

  @Input()
  title: string;

  @Input()
  btnRaised: boolean;

  color: string;

  constructor() { }

  ngOnInit() {
    this.btnType = this.btnType || 'button';
    this.btnClass = 'dcsg-mat-spinner-button__button ' + this.btnClass;
    this.btnRaised = (this.btnRaised === undefined) ? true : this.btnRaised;
    this.color = this.btnClass.includes('primary') ? 'primary' : 'accent';
  }

}
